<template>
    <div class="full-width">
        <div class="img-part">
            <div class="img-box">
                <img :src="imgUrl">
            </div>
        </div>

        <div class="title-part">
            <span>{{productName}}</span>
        </div>

        <div class="des-part">
            <span>{{description}}</span>
        </div>

        <div class="operation-box">
            <el-button type="primary" @click="clickChat">{{i18n.tkey("lang_communicate")}}</el-button>
            &nbsp;
            <a :href="jumpUrl" target="web">
                <el-button tkey="查看">{{i18n.tkey("lang_check")}}</el-button>
            </a>
        </div>
    </div>
</template>

<script setup>

import {inject, toRef, computed} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";

const props = defineProps(["obj"])
const emits = defineEmits(["clickChat"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

const imgUrl = computed(() => {
    let url = ""

    if (null != props.obj){
        url = myUtil.generateProductImg(props.obj)
    }

    return url
})

const productName = computed(() => {
    let name = ""

    if (null != props.obj){
        name = props.obj.productnamecn

        if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
            name = props.obj.productname
        }
    }

    return name
})

const description = computed(() => {
    let des = ""

    if (null != props.obj){
        des = props.obj.description2

        if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
            des = props.obj.description
        }

    }

    return des
})

const jumpUrl = computed(() => {
    let url = "javascript: void(0)"

    if (null != props.obj){
        url = myUtil.generateEshopopeeProductPageUrl(props.obj)
    }

    return url
})

function clickChat(){
    emits("clickChat", props.obj)
}

</script>

<style scoped>

.full-width {
    width: 100%;
    box-sizing: border-box;
}

.img-part {
    text-align: center;
}

.img-box {
    position: relative;
    width: 70%;
    padding-top: 70%;
    margin: auto;
}

.img-box img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: scale-down;
    box-sizing: border-box;
    border: 1px #F5F7FA solid;
}

.title-part {
    font-size: 14px;
    //margin-bottom: 20px;
    //margin-top: 20px;
    margin-bottom: 5px;
    margin-top: 10px;
    font-weight: 600;
    color: #303133;
}

.des-part {
    text-align: left;
    font-size: 12px;
    color: #606266;
    line-height: 2;
    width: 70%;
    margin: auto;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
}

.operation-box {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
}

</style>